import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "visitor"
};
const _hoisted_2 = {
  key: 1,
  class: "content"
};
const _hoisted_3 = {
  class: "line"
};
const _hoisted_4 = {
  class: "left"
};
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = {
  class: "first"
};
const _hoisted_7 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_search = _resolveComponent("van-search");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_back_top = _resolveComponent("van-back-top");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "入校预约"
  }, {
    right: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "plus",
      color: "#000",
      size: "20",
      onClick: _ctx.toVisitorAdd
    }, null, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_van_search, {
    modelValue: _ctx.searchValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.searchValue = $event),
    placeholder: "请输入访客姓名进行搜索",
    onSearch: _ctx.onRefresh
  }, null, 8, ["modelValue", "onSearch"]), _createVNode(_component_van_pull_refresh, {
    modelValue: _ctx.refreshing,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.refreshing = $event),
    "success-text": "刷新成功",
    onRefresh: _ctx.onRefresh
  }, {
    default: _withCtx(() => [!_ctx.list.length ? (_openBlock(), _createBlock(_component_van_empty, {
      key: 0,
      description: "暂无数据"
    })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = $event => _ctx.loading = $event),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onLoad,
      class: "list"
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_van_image, {
          round: "",
          width: "40",
          height: "40",
          src: item.photoPath
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(item.name) + "的入校预约", 1), item.status == 0 ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 0,
          type: "success"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("审核通过")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 1 ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 1,
          type: "warning"
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("待审核")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 2 ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 2,
          type: "danger"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("审核不通过")])),
          _: 1
        })) : _createCommentVNode("", true)]), _createElementVNode("p", null, [_cache[6] || (_cache[6] = _createElementVNode("span", null, "开始时间：", -1)), _createTextVNode(_toDisplayString(item.beginTime), 1)]), _createElementVNode("p", null, [_cache[7] || (_cache[7] = _createElementVNode("span", null, "结束时间：", -1)), _createTextVNode(_toDisplayString(item.endTime), 1)]), _createElementVNode("p", null, [_cache[8] || (_cache[8] = _createElementVNode("span", null, "预约事由：", -1)), _createTextVNode(_toDisplayString(item.visitReason), 1)])])]), _createVNode(_component_van_divider, {
          hairline: "",
          style: {
            margin: 0
          }
        })]);
      }), 128))]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]), _createVNode(_component_van_back_top)]))]),
    _: 1
  }, 8, ["modelValue", "onRefresh"])]);
}